import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';

export const getCommandJobDetails = (commandJobId) => {
  return Helpers.get(`${Constants.DEPLOY_PACKAGES_URL}/user/${commandJobId}`);
};

export const getCommandJobs = () => {
  return Helpers.get(`${Constants.DEPLOYMENT_JOBS_URL}/command`);
};

export const getFleets = () => {
  return Helpers.get(Constants.FLEETS_URL);
};

export const getPackages = () => {
  return Helpers.get(`${Constants.UPDATE_PACKAGES_URL}/command`);
};

export const deployPackage = (packageId, fleetId) => {
  return Helpers.post(`${Constants.DEPLOY_PACKAGES_URL}/${packageId}/fleet/${fleetId}`);
};

export const getReadOnlyBlobSasToken = (serialNumber, guid) => {
  let query = {
    serialNumber: serialNumber,
    guid: guid,
  };

  return Helpers.get(`${Constants.FILE_TRANSFER_URL}/sasToken/instrumentCommandResult`, {}, query);
};
